import React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { ListAtomState } from '../../../recoil/ModalAtom';
import { formatManWon } from '../../../utils/formatNumber';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled.div``;

const Title = styled.h2`
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
  color: ${p => p.theme.text};
`;

const SubTitle = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${p => p.theme.textMuted};
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${p => p.theme.bgCard};
  border: 1px solid ${p => p.theme.border};
  border-radius: ${p => p.theme.radius};
  overflow: hidden;
`;

const Th = styled.th`
  text-align: left;
  background: ${p => p.theme.bgInput};
  color: ${p => p.theme.textSecondary};
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 600;
  border-bottom: 1px solid ${p => p.theme.border};

  &:last-child {
    text-align: right;
  }
`;

const Td = styled.td`
  padding: 14px 16px;
  font-size: 13px;
  color: ${p => p.theme.text};
  border-bottom: 1px solid ${p => p.theme.border};

  @media screen and (max-width: 540px) {
    padding: 10px 12px;
    font-size: 12px;
  }
`;

const PriceTd = styled(Td)`
  text-align: right;
  font-weight: 700;
  white-space: nowrap;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 16px 20px;
  background: ${p => p.theme.bgCard};
  border: 1px solid ${p => p.theme.border};
  border-radius: ${p => p.theme.radius};
`;

const TotalLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${p => p.theme.text};
`;

const TotalAmount = styled.span`
  font-size: 24px;
  font-weight: 800;
  color: ${p => p.theme.accent};

  @media screen and (max-width: 540px) {
    font-size: 18px;
  }
`;

const DownloadButton = styled.button`
  align-self: flex-end;
  padding: 12px 20px;
  background: ${p => p.theme.accent};
  color: #fff;
  border: none;
  border-radius: ${p => p.theme.radiusSm};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: ${p => p.theme.transition};

  &:hover {
    background: ${p => p.theme.accentHover};
  }
`;

const Empty = styled.div`
  padding: 40px;
  text-align: center;
  color: ${p => p.theme.textMuted};
  background: ${p => p.theme.bgCard};
  border: 1px dashed ${p => p.theme.border};
  border-radius: ${p => p.theme.radius};
  font-size: 13px;
`;

export default function Step4Review() {
  const itemStack = useRecoilValue(ListAtomState);
  const total = itemStack.reduce((sum, i) => sum + (Number(i.PRICE) || 0), 0);

  return (
    <Wrap>
      <Header>
        <Title>견적 확인</Title>
        <SubTitle>선택하신 항목과 예상 견적을 확인해주세요.</SubTitle>
      </Header>

      {itemStack.length === 0 ? (
        <Empty>아직 선택된 항목이 없습니다. 이전 단계에서 개발환경과 기능을 선택해주세요.</Empty>
      ) : (
        <Table>
          <thead>
            <tr>
              <Th>항목</Th>
              <Th>설명</Th>
              <Th>비용</Th>
            </tr>
          </thead>
          <tbody>
            {itemStack.map((item, i) => (
              <tr key={i}>
                <Td>{item.NAME}</Td>
                <Td style={{ color: '#64748b' }}>{item.DESCRIPTION}</Td>
                <PriceTd>{formatManWon(item.PRICE)} 만원</PriceTd>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <TotalRow>
        <TotalLabel>총 예상 견적 (VAT 별도)</TotalLabel>
        <TotalAmount>{formatManWon(total)} 만원</TotalAmount>
      </TotalRow>

      <DownloadButton>견적서 다운로드</DownloadButton>
    </Wrap>
  );
}
